(function (sculpteo) {
  "use strict";

  const WelcomeSurvey = (sculpteo.WelcomeSurvey = function () {
    let $modal = $("#welcome-survey-modal");
    let $modalBackground = $("#welcome-survey-modal-background");

    const portalId = "5154612";

    const formIds = {
      en: "076e552a-9c33-4b79-8c53-90a894b56f61",
      fr: "2be6f6b9-eee9-40e7-8619-df442770e64d",
      es: "076e552a-9c33-4b79-8c53-90a894b56f61",
      de: "076e552a-9c33-4b79-8c53-90a894b56f61",
    };

    var createDOM = function () {
      const rawLang = $("html").attr("lang").toLowerCase(); // get the language from the page's html attribute
      const lang = rawLang.substring(0, 2) || "en"; // use first two letters only, default to 'en' if not found

      if (!formIds.hasOwnProperty(lang)) {
        console.warn("No survey for language", lang);
        return;
      }

      const html =
        '<script src="https://js.hsforms.net/forms/embed/' +
        portalId +
        '.js" defer></script>' +
        '<div class="hs-form-frame" data-region="na1" data-form-id="' +
        formIds[lang] +
        '" data-portal-id="' +
        portalId +
        '"></div>';

      $modal = $(
        "<div id='welcome-survey-modal' class='sculpteo-modal modal--center modal--large modal--responsive'/>"
      );
      $modal.append($("<div class='modal-container'/>").html(html));
      $modalBackground = $(
        "<div id='welcome-survey-modal-background' class='modal-background'></div>"
      );

      $modalBackground.hide();
      $modal.hide();

      $("body").append($modal);
      $("body").append($modalBackground);

      // avoid showing a blank modal while the iframe loads
      // we detect when the iframe is added to the DOM so that we can listen for its load event
      // call .show() only after the iframe has fully loaded
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          for (var i = 0; i < mutation.addedNodes.length; i++) {
            var node = mutation.addedNodes[i];
            if (node.tagName && node.tagName.toLowerCase() === "iframe") {
              // the iframe has just been added by the HubSpot script, add a listener for the load event
              node.addEventListener("load", function () {
                // the iframe loading is complete, we can show the modal now
                setTimeout(function () {
                  $modal.show();
                  $modalBackground.show();
                }, 50); // add a slight delay to ensure content is really ready
              });
            }
          }
        });
      });
      var parent = $modal.get(0);
      observer.observe(parent, {
        childList: true,
        subtree: true,
      });

      $modalBackground.on("click", this.close.bind(this));
    };

    this.open = function () {
      if (!$modal.length && !$modalBackground.length) {
        createDOM.bind(this)();
      } else {
        $modal.show();
        $modalBackground.show();
      }
    };

    this.close = function () {
      $modalBackground.hide();
      $modal.hide();
    };
  });
})((window.sculpteo = window.sculpteo || {}));
